(function () {
	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true,
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms = {
				parallax: box.data("parallax"),
				effect: box.data("effect"),
				speed: speed,
				// With the fade effect, `rewind` wraps last -> first with the same cross-fade as `loop`, but
				// without cloning slides. The clones were painted after load and counted by Chrome as a
				// late LCP (~2.5s after the real hero), and duplicated the first slide's H1.
				loop: box.data("effect") !== "fade",
				rewind: box.data("effect") === "fade",
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				creativeEffect: {
					prev: {
						shadow: false,
						translate: [0, 0, -400],
					},
					next: {
						translate: ["100%", 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: false,
				},
				flipEffect: {
					slideShadows: false,
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: "true",
					type: 'custom',
					renderCustom: function (swiper, current, total) {
						return `
						<span class="current-slide">${ current < 10 ? '0' + current : current }</span>
						<span class="swiper-pagination-delimiter"></span>
						<span class="total-slides">${ total < 10 ? '0' + total : total }</span>`
				}
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
			if (autoplay && !(window.Shopify && Shopify.designMode)) holdAutoplay(swiper);
			swiper.on("slideChange", function () {
				// Hand the first slide's text reveal back to Swiper's active/prev/next classes.
				this.el.querySelectorAll(".is-initial").forEach((el) => el.classList.remove("is-initial"));
				colorScheme(this);
			});

			function colorScheme(context) {
				//const parent = $(context.el).parent();
				const parent = box.find(".swiper-controllers");
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [parent[0]];
				const colorScheme = $(activeSlide)
					.find(".slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					const classes = item.classList;
					for (let className of classes) {
						if (/color-background-\d+$/.test(className)) {
							item.classList.remove(className);
						}
					}
					item.classList.add(colorScheme);
				});
			}
		});
	};

	// The hero's first slide stays put until the visitor interacts with the page (or 10s after load),
	// then autoplay runs as configured. Swapping the whole viewport while the page is still loading
	// costs Speed Index / perceived load, and nobody has looked at slide one yet.
	function holdAutoplay(swiper) {
		swiper.autoplay.stop();
		const events = ["pointerdown", "keydown", "touchstart", "wheel", "mousemove", "scroll"];
		let fallback;
		const start = () => {
			events.forEach((e) => removeEventListener(e, start, { passive: true }));
			clearTimeout(fallback);
			if (!swiper.destroyed) swiper.autoplay.start();
		};
		events.forEach((e) => addEventListener(e, start, { passive: true, once: true }));
		const arm = () => (fallback = setTimeout(start, 10000));
		document.readyState === "complete" ? arm() : addEventListener("load", arm, { once: true });
	}

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
